import httpManager from "@/app/shared/utils/httpManager";

export async function fetchPortfolioById(portfolioId) {
  return await httpManager.get(`/portfolios/${portfolioId}/`);
}
